import React,{ useContext, useState,useEffect } from "react";
import BackButton from '../../components/BackButton/BackButton'
import "./style.css"
import img from "./imageHelp.png"
import { Button }  from 'react-bootstrap';
import HelpIcon from '@material-ui/icons/Help';
import ShowChartIcon from '@material-ui/icons/ShowChart';




export default function HelpIndex() {
    return(
        <>
        <BackButton />
        <div className="divcenter">
          <img src={img} alt="" className="img_css"></img>
          <h1 className="textcenter">
            Você já consultou o manual e os vídeos localizados ao lado esquerdo do
            botão de Ajuda, no topo da tela? Você ainda precisa de ajuda?
          </h1>
          <h2 className="textcenter">
            Caso não tenha encontrado a solução do seu problema, entre em contato
            conosco!
          </h2>
          <hr />
          <div className="buttons_help">
            <Button
              className="mb-3 mt-3 ml-2"
              size="lg"
              variant="success"
              href="https://nestle.service-now.com/sp?id=sc_cat_item&sys_id=a852532e1bbb3814f88c840de54bcbe7&sysparm_domain_restore=false&sysparm_stack=no"
              target="blank"
            >
              Ajuda com Problema ou Bugs
              <HelpIcon className="ml-2" />
            </Button>
            <Button
              className="mb-3 mt-3 ml-2"
              size="lg"
              href="https://nestle.service-now.com/sp?id=sc_cat_item&sys_id=e55e0fee1b3b3814f88c840de54bcbd8&sysparm_domain_restore=false&sysparm_stack=no"
              target="blank"
            >
              <ShowChartIcon className="mr-2" />
              Sugestão Melhoria ou Solicitação
            </Button>
          </div>
        </div>
      </>
    )

}